import type { CategoryModel } from '@/shared/generated'

import { map, pipe, uniqBy } from 'lodash/fp'

import { getTree } from '@/shared/lib/tree'

export const toCategoriesTree = pipe([
	map((cat: CategoryModel) => ({ ...cat, parent: cat.parent_id })),
	uniqBy('id'),
	getTree,
])
